var map = {
	"./cs.json": [
		1491,
		1491
	],
	"./de.json": [
		13814,
		13814
	],
	"./en.json": [
		62094,
		62094
	],
	"./es.json": [
		64645,
		64645
	],
	"./fr.json": [
		12525,
		12525
	],
	"./it.json": [
		1592,
		1592
	],
	"./ja.json": [
		5900,
		5900
	],
	"./ko.json": [
		37343,
		37343
	],
	"./pl.json": [
		51330,
		28949
	],
	"./pt-br.json": [
		60216,
		60216
	],
	"./pt.json": [
		39309,
		39309
	],
	"./ru.json": [
		92520,
		92520
	],
	"./tr.json": [
		97675,
		97675
	],
	"./zh.json": [
		97447,
		97447
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85536;
module.exports = webpackAsyncContext;